import React from 'react';
import { Bell } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

export const OptionsAlertsInboxButton = ({ notifications = [], unreadCount = 0, onMarkRead, busy = false }) => {
  const { t } = useOptionsLocale();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-white/75 transition-colors hover:bg-white/10 hover:text-white" data-testid="options-alerts-inbox-trigger">
          <Bell size={16} />
          {unreadCount ? <span className="absolute -right-1 -top-1 inline-flex min-w-[18px] items-center justify-center rounded-full bg-[#F0B90B] px-1 text-[10px] font-bold text-black" data-testid="options-alerts-inbox-badge">{unreadCount}</span> : null}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[360px] border-white/10 bg-[#07111f] p-0 text-white" data-testid="options-alerts-inbox-content">
        <div className="border-b border-white/10 px-4 py-3">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-white/45">{t('optionsAlerts.recentNotifications')}</p>
        </div>
        <div className="max-h-[420px] space-y-1 overflow-y-auto px-2 py-2">
          {notifications.length ? notifications.map((item) => (
            <div key={item.id} className="rounded-2xl border border-white/10 bg-white/[0.03] px-3 py-3" data-testid={`options-alerts-inbox-item-${item.id}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="space-y-1">
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-semibold text-white">{item.title}</p>
                    {!item.read_at ? <Badge className="bg-[#F0B90B]/15 text-[#F0B90B]">{t('optionsAlerts.unread')}</Badge> : null}
                  </div>
                  <p className="text-xs text-white/58">{item.message}</p>
                  <p className="text-[11px] uppercase tracking-[0.18em] text-white/38">{item.observed_value_label} · {item.threshold_label}</p>
                </div>
                {!item.read_at ? (
                  <Button type="button" variant="ghost" size="sm" className="text-white/70 hover:bg-white/10 hover:text-white" disabled={busy} onClick={() => onMarkRead(item.id)} data-testid={`options-alerts-inbox-mark-read-${item.id}`}>
                    {t('optionsAlerts.markRead')}
                  </Button>
                ) : null}
              </div>
            </div>
          )) : (
            <div className="px-4 py-10 text-center text-sm text-white/58" data-testid="options-alerts-inbox-empty">{t('optionsAlerts.emptyNotifications')}</div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default OptionsAlertsInboxButton;